import React from "react";
import { Box, Container, Typography, Link } from "@mui/joy";

const SectionTitle: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Typography
    level="h3"
    sx={{
      fontWeight: 600,
      fontSize: "1.25rem",
      color: "#1A1B1D",
      mb: 1,
      mt: 3,
    }}
  >
    {children}
  </Typography>
);

const SectionText: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography
    level="body-lg"
    sx={{
      lineHeight: 1.6,
      color: "#7B7F85",
      mb: 2,
    }}
  >
    {children}
  </Typography>
);

const TermsOfServicePage: React.FC = () => {
  return (
    <Box sx={{ minHeight: '100vh', py: 4, backgroundColor: '#F8F9FA' }}>
      <Container maxWidth="md">
        <Box
          sx={{
            backgroundColor: 'white',
            borderRadius: '16px',
            p: { xs: 3, md: 6 },
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          }}
        >
          <Typography
            level="h1"
            sx={{
              fontSize: { xs: "2rem", md: "2.5rem" },
              fontWeight: 600,
              color: "#1A1B1D",
              mb: 3,
              textAlign: 'center',
            }}
          >
            Terms of Service
          </Typography>

          <SectionText>
            By uploading a video to this website as part of your job application
            (the <strong>"Video"</strong>), you agree to the following terms:
          </SectionText>

          <SectionTitle>1. Consent to Share</SectionTitle>
          <SectionText>
            You grant us permission to share your Video, and any associated
            information you provide, with other companies or employers who may be
            interested in hiring you.
          </SectionText>

          <SectionTitle>2. Internal Review and Rating</SectionTitle>
          <SectionText>
            You agree that we may internally view, rate, and assess your Video and
            application materials to evaluate your candidacy and improve our
            recruitment process.
          </SectionText>

          <SectionTitle>3. Use for Research and Training</SectionTitle>
          <SectionText>
            You grant us the right to use your Video for internal research,
            training, and development purposes, including but not limited to
            studying interview patterns, improving candidate evaluation methods,
            and developing hiring-related tools or insights.
          </SectionText>

          <SectionTitle>4. Data Privacy</SectionTitle>
          <SectionText>
            We will treat your information with respect and in accordance with our{" "}
            <Link href="/privacy" sx={{ color: "#2E2D7E", fontWeight: 600 }}>
              Privacy Policy
            </Link>
            {" "}, which explains how we collect, use, and protect your
            personal data.
          </SectionText>

          <SectionTitle>5. No Guarantee of Employment</SectionTitle>
          <SectionText>
            Submission of a Video or application does not guarantee job placement
            or employment by us or any third-party company.
          </SectionText>

          <SectionTitle>6. Retention</SectionTitle>
          <SectionText>
            We may retain your Video and application materials for as long as
            necessary for the purposes outlined above, unless you request
            deletion.
          </SectionText>

          <SectionTitle>7. Your Rights</SectionTitle>
          <SectionText>
            You may contact us at{" "}
            <Link 
              href="mailto:dalton@geekapp.co" 
              sx={{ color: "#2E2D7E", fontWeight: 600 }}
            >
              dalton@geekapp.co
            </Link>{" "}
            to request access to, correction of, or deletion of your Video and
            personal data, subject to legal and operational limitations.
          </SectionText>

          <SectionText>
            If you do not agree to these terms, please do not submit a Video or
            any application materials through this website.
          </SectionText>
        </Box>
      </Container>
    </Box>
  );
};

export default TermsOfServicePage;
